import { useSelector } from "react-redux";
import useSearchParams from "../../../hooks/useSearchParams";
import { useParams } from "react-router-dom";
import getParamsFromVariationId from "../utils/getParamsFromVariationId";
import getVariationIdFromCombo from "../utils/getVariationIdFromCombo";
import { selectColorSuffixes } from "../configurationsSlice";

const useParameters = ({ parameters }) => {
  const { getParam, setParam } = useSearchParams();
  const { configurationId } = useParams();
  const extraSuffixes = useSelector(selectColorSuffixes(configurationId));
  const activeVariation = getParam("var");
  const selectedParamValues = getParamsFromVariationId(
    configurationId,
    activeVariation,
    parameters,
    extraSuffixes,
  );
  const parameterChips = parameters.map((parameter) => ({
    ...parameter,
    selectedValue: selectedParamValues.find(
      (selectedParam) => selectedParam.id === parameter.id
    )?.value,
  }));

  const handleClick = (data) => {
    const newCombo = selectedParamValues
      .map((paramValue) => {
        if (paramValue.id !== data.id) {
          return paramValue.value;
        }
        return data.value;
      })
      .filter((v) => v != null);
    const newVariationId = getVariationIdFromCombo(configurationId, newCombo, extraSuffixes);
    setParam("var", newVariationId);
  };

  return { handleClick, parameters: parameterChips };
};

export default useParameters;
